/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { PropsWithChildren, ReactNode } from 'react'
import { AppShell, AppShellProps, Center } from '@mantine/core'
import { Outlet } from 'react-router-dom'

export type CenterLayoutProps = AppShellProps
  & PropsWithChildren
  & {
  headerContent?: ReactNode
}

function CenterLayout (props: CenterLayoutProps) {
  const { children, headerContent, ...others } = props
  return (
    <AppShell
      className="CenterLayout"
      h="100dvh"
      header={{ height: headerContent ? 60 : undefined }}
      {...others}
    >
      <AppShell.Header>
        {headerContent}
      </AppShell.Header>

      <AppShell.Main h="100%">
        <Center h="100%">
          <Outlet />
          {children}
        </Center>
      </AppShell.Main>
    </AppShell>
  )
}

export default CenterLayout
